import request from '@/utils/request'

const url = '/home/user/'
const api = {
  subMember (data) {
    return request({
      url: url + 'subMember',
      method: 'post',
      data
    })
  },
  getMyLike (data) {
    return request({
      url: url + 'getMyLike',
      method: 'post',
      data
    })
  },
  getMyHistory (data) {
    return request({
      url: url + 'getMyHistory',
      method: 'post',
      data
    })
  },
  savePassword (data) {
    return request({
      url: url + 'savePassword',
      method: 'post',
      data
    })
  },
  saveTel (data) {
    return request({
      url: url + 'saveTel',
      method: 'post',
      data
    })
  },
  saveEmail (data) {
    return request({
      url: url + 'saveEmail',
      method: 'post',
      data
    })
  },
  delCollect (data) {
    return request({
      url: url + 'delCollect',
      method: 'post',
      data
    })
  },
  delHistorys (data) {
    return request({
      url: url + 'delHistorys',
      method: 'post',
      data
    })
  },
  UpdateGoodsPB (data) {
    return request({
      url: '/home/UpdateGoodsPB/importBusOrder',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/user.js